import moment from "moment"
import settings from '@/settings.coffee'

filters = {
    format_float: (value) ->
        formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        return formatter.format(value)
    human_date: (date)->
        return moment(date).fromNow()
    local_date: (date)->
        return moment(date).format("DD/MM/YYYY")
    as_media: (path)->
        return settiongs.backendMediaUrl + path
    as_css_background: (path)->
        return {
            'background-image':'url('+settings.backendMediaUrl + path+')'
        }
    as_css_background_string: (path)->
        return 'url('+settings.backendMediaUrl + path+')'
    ifempty: (text, default_text)->
        ret = text
        if text == ''
            ret = default_text
        return ret
    ellipsis: (text, cutoff)->
        cutoff = cutoff or 25
        # keep = Number(text.length / 4)
        keep = 10
        if text.length > cutoff
            result = text.slice(0, keep)+" ... "+text.slice(-keep)
        else
            result = text
        return result
    as_establishment: (text)->
        ret = text
        if text == "Réponse en cours de rédaction"
            ret = "Réponse à valider"
        else if text == "Classé"
            ret = "Traité"
        return ret
    round: (value, decimals)->
        intl =  new Intl.NumberFormat('fr-FR', {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
        return intl.format(value) 
}

export default {filters}
